import { Brand } from '@blade/std-lib'

export const AttachmentIdTypeId = 'tradebot-tma/AttachmentId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AttachmentIdTypeId = typeof AttachmentIdTypeId

export type AttachmentId = Brand.Branded<string, AttachmentIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentId = Brand.nominal<AttachmentId>()
